<report-grid-wrapper #gridWrapper [header]="header" [headerTag]="'h4'" [accountId]="accountId">
	<vb-ui-data-grid [ngClass]="styles.grid" [context]="gridWrapper.gridProperties.context" [defaultColDef]="gridWrapper.gridProperties.defaultColDef" [gridOptions]="gridWrapper.gridProperties.options" [columnDefs]="columnDefs" [rowData]="data$ | async">
	</vb-ui-data-grid>
</report-grid-wrapper>
